module.exports = {
  getPublicPath,
  getDynamicIconPath
};

function getPublicPath() {
  return process.env.VUE_APP_SIT_CONTEXT || './';
}
function getDynamicIconPath(icon) {
  return `${getPublicPath()}CommonDp/dynamicRouterIcon/`;
}